import { useState } from "react";
import { api } from "@/lib/api";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export default function ContactModal({ open, onOpenChange }) {
  const [contactForm, setContactForm] = useState({
    fullName: "",
    email: "",
    mobile: "",
  });
  const [contactLoading, setContactLoading] = useState(false);
  const [contactSuccess, setContactSuccess] = useState(false);

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    if (!contactForm.fullName.trim() || !contactForm.email.trim() || !contactForm.mobile.trim()) {
      alert("All fields are mandatory.");
      return;
    }
    setContactLoading(true);
    try {
      await api.post("/enquiry", contactForm);
      setContactSuccess(true);
      setContactForm({ fullName: "", email: "", mobile: "" });
    } catch (err) {
      alert("Something went wrong. Please try again.");
    } finally {
      setContactLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(val) => {
      onOpenChange(val);
      if (!val) {
        setTimeout(() => setContactSuccess(false), 200);
      }
    }}>
      <DialogContent className="sm:max-w-md border-slate-100 rounded-2xl bg-white p-6 shadow-2xl">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-slate-900 text-center">
            {contactSuccess ? "Enquiry Submitted!" : "Contact Our Experts"}
          </DialogTitle>
          <DialogDescription className="text-sm text-slate-500 text-center mt-1">
            {contactSuccess
              ? "Your enquiry has been successfully logged."
              : "Fill out the form below to get in touch with our financial advisors."}
          </DialogDescription>
        </DialogHeader>

        {contactSuccess ? (
          <div className="flex flex-col items-center py-6 text-center">
            <div className="w-16 h-16 rounded-full bg-emerald-50 text-emerald-500 flex items-center justify-center mb-4 animate-bounce">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-sm font-semibold text-slate-900">Thank you for reaching out!</p>
            <p className="text-xs text-slate-500 mt-2 max-w-xs leading-relaxed">
              We'll review your enquiry and get back to you within 24 hours.
            </p>
            <button
              onClick={() => onOpenChange(false)}
              className="mt-6 px-6 py-2 bg-sif-primary text-white text-xs font-semibold rounded-lg hover:opacity-90 transition"
            >
              Close Window
            </button>
          </div>
        ) : (
          <form onSubmit={handleContactSubmit} className="space-y-4 py-2">
            <div className="space-y-1">
              <label className="text-xs font-bold text-slate-700 uppercase tracking-wider">Full Name *</label>
              <input
                type="text"
                required
                placeholder="e.g. Ashish Bhave"
                value={contactForm.fullName}
                onChange={(e) => setContactForm({ ...contactForm, fullName: e.target.value })}
                className="w-full px-3.5 py-2.5 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-sif-primary/20 transition"
              />
            </div>

            <div className="space-y-1">
              <label className="text-xs font-bold text-slate-700 uppercase tracking-wider">Email Address *</label>
              <input
                type="email"
                required
                placeholder="e.g. exampleuser@example.com"
                value={contactForm.email}
                onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
                className="w-full px-3.5 py-2.5 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-sif-primary/20 transition"
              />
            </div>

            <div className="space-y-1">
              <label className="text-xs font-bold text-slate-700 uppercase tracking-wider">Mobile Number *</label>
              <input
                type="tel"
                required
                placeholder="10 Digit Mobile number"
                value={contactForm.mobile}
                onChange={(e) => setContactForm({ ...contactForm, mobile: e.target.value })}
                className="w-full px-3.5 py-2.5 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-sif-primary/20 transition"
              />
            </div>

            <button
              type="submit"
              disabled={contactLoading}
              className="w-full mt-2 py-2.5 rounded-lg bg-sif-primary text-white text-sm font-semibold text-center hover:opacity-90 disabled:opacity-50 transition"
            >
              {contactLoading ? "Submitting..." : "Submit Enquiry"}
            </button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
